import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { IFurnizor, IFurnizorForm, IFurnizorUpdatePayload } from '../furnizori-proiecte.interface';
import { FurnizoriProiecteService } from '../furnizori-proiecte.service';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-edit-furnizori-proiecte',
    templateUrl: './edit-furnizori-proiecte.component.html',
    styleUrls: ['./edit-furnizori-proiecte.component.scss']
})
export class EditFurnizoriProiecteComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    provider_type: { key: string; value: string }[] = [
        { key: '--Alegeți--', value: '-1' },
        { key: 'Firmă', value: '1' },
        { key: 'Instituție Publică (Regie Propie)', value: '2' },
        { key: 'Firmă și Instituție Publică', value: '3' },
    ];

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        provider_type: new FormControl(this.data.provider_type.toString(), [Validators.required, Validators.min(0)]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: IFurnizor,
        private dialogRef: MatDialogRef<EditFurnizoriProiecteComponent>,
        private furnizoriProiecteService: FurnizoriProiecteService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const {
            name,
            provider_type,
        } = this.form.value as IFurnizorForm;
        const payload: IFurnizorUpdatePayload = {
            id: this.data.id,
            name,
            provider_type
        };

        this.furnizoriProiecteService
            .updateFurnizor(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
